const utils = require("frontend-controller/lib/utils");
module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form',
    ],

    config: {
        isFullyVertical: true,
        forceNonDirtyValidation: true,
    },

    methods: {

        /**
         * this function will be called after the response of a submit request has returned.
         *
         * @param   response        {} - server response
         * @param   insertionDone   boolean - has an insert been performed or not
         */
        onSubmit(response, insertionDone){
            this.closest('base_tabStrip_tabStrip', tabStrip => {
                if(tabStrip.stepComplete){
                    tabStrip.stepComplete()
                }
                tabStrip.focusNextTab()
            })
        },

        /**
         * this function will be called after the form has not been sent due to missing changes.
         */
        onSubmitNothing(){
            this.closest('base_tabStrip_tabStrip', tabStrip => {
                if(tabStrip.stepComplete){
                    tabStrip.stepComplete()
                }
                tabStrip.focusNextTab()
            })
        },

        async handleError(context){
            const errorCode = ((context || {}).error || {}).errorCode || ''

            if(errorCode === 'CREDENTIALS_ROUTE_ERROR'){
                return this.performAction(
                    this.prepareAction('message', undefined, {
                        messageDisplay: {
                            message: 'error:registration.credentialsRouteError'
                        }
                    }, {
                        statusControllerLoadingMessage: '',
                        statusControllerSavingMessage:  ''
                    })
                )
            }

            context.errorUnhandled = true
            return utils.promise.resolve(context)
        },
    }
}